import { Router } from '@angular/router';
import { Component } from '@angular/core';
import { SharedService } from 'src/app/services/shared.service';
import { CatalogsService } from 'src/app/services/catalogs.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { FiltrarProyectosService } from 'src/app/services/filtrar-proyectos.service';

@Component({
  selector: 'app-proyectos',
  templateUrl: './proyectos.component.html',
  styleUrls: ['./proyectos.component.css']
})
export class ProyectosComponent {

  proyectos: any[] = [];
  searchTerm: string = '';
  originalProyectos: any[] = [];
  loading: boolean = true;
  usuarioId: any;
  rol: any;
  mensajeProyectos: string = '';
  public token: any;

  constructor(
    private router: Router,
    private sharedService: SharedService,
    private requestsService: CatalogsService,
    private navigationService: NavigationService,
    private filtrarProyectosService: FiltrarProyectosService
  ) { }

  ngOnInit() {
    this.verificacionUsuario();
  }

  verificacionUsuario() {
    this.navigationService.disableNavigation();
    const { rol, usuarioId, token } = this.filtrarProyectosService.validacionUsuarios();
    this.token = token;
    this.rol = rol;
    this.usuarioId = usuarioId;

    this.requestsService.getAllProjects(this.token).subscribe(
      (data: any) => {
        // desactiva el login 
        this.loading = false;
        this.obtenerProyecto(data);
      });
  }


  obtenerProyecto(data: any) {
    // guardamos los datos originales 
    this.originalProyectos = Object.values(data);
    if (this.rol === 'Administrador') {
      this.proyectos = data;
    } else {
      const { proyectosFiltrados } = this.filtrarProyectosService.filtrarProyectos(data, this.usuarioId);
      this.proyectos = proyectosFiltrados;
    }

    this.proyectos.length === 0 && this.mensajeError(`No se tienen proyectos que mostrar.`);
  }

  search() {
    if (this.searchTerm) {
      this.buscador();
    } else {
      this.proyectos = this.originalProyectos;
    }
  }

  buscador() {
    this.proyectos = this.originalProyectos.filter(proyectos => {
      return (
        proyectos.Pry_DirClave.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        proyectos.Pry_Clave.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
        proyectos.Pry_Nombre.toLowerCase().includes(this.searchTerm.toLowerCase())
      );
    });
    this.proyectos.length === 0 && this.mensajeError(`Con los criterios ${this.searchTerm}, no encontramos ninguna coincidencia.`);
  }

  mensajeError(mensaje: string) {
    this.mensajeProyectos = mensaje;
  }

  editar(op: any, proyecto: any) {
    const opE = op.toString()
    this.sharedService.setData(opE);
    this.sharedService.setDataArray(proyecto);
    this.router.navigate(['/proyectosD', opE]);
  }

  agregar(op: any) {
    const opE = op.toString()
    this.sharedService.setData(opE);
    this.router.navigate(['/proyectosD', opE]);
  }

}